interface IInputProps {
  label: string;
  className?: string;
  inputProps?: any;
  onChange?: (value: string) => void;
}

const Input: React.FunctionComponent<IInputProps> = ({
  label = "",
  className = "",
  inputProps = {},
  onChange = () => {},
}) => {
  return (
    <div className={className}>
      <label>
        <span className="text-sm font-semibold">{label}</span>
        <div className="bg-gray-50 border rounded-sm p-1">
          <input
            {...inputProps}
            className="outline-none bg-transparent w-full"
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      </label>
    </div>
  );
};

export default Input;
